import { Button, Text } from '@ksyos/design-system';
import { ProcessEntity } from '../../../common/enums/processEntity';
import { ServiceType } from '../../../common/enums/serviceType';
import { translateKey } from '../../translate';
import { Component } from './Component';
import { Modal } from './modals/Modal';

interface ISureToCancelModalProps {
    entity: ProcessEntity;
    isExisting: boolean;
    isInReadMode: boolean;
    onNo: () => Promise<void>;
    onYes: () => Promise<void>;
    serviceType?: ServiceType;
}

interface ISureToCancelModalState {
    processType?: string;
}

export class SureToCancelModal extends Component<ISureToCancelModalProps, ISureToCancelModalState> {
    public async componentDidMount() {
        await this.getProcessType();
    }

    public render() {
        if (!this.state.processType) {
            return null;
        }

        return (
            <Modal
                actionButtons={[
                    <Button
                        onClick={async () => await this.props.onNo()}
                        variant="outline"
                    >
                        {translateKey('common.no')}
                    </Button>,
                    <Button onClick={async () => await this.props.onYes()}>{translateKey('common.yes')}</Button>,
                ]}
                isOpen
                onClose={async () => await this.props.onNo()}
                size="small"
                title={translateKey('common.cancelForm')}
            >
                <Text>{this.getModalText()}</Text>
            </Modal>
        );
    }

    private async getProcessType() {
        let entity: string = this.props.entity;

        if (this.props.entity === ProcessEntity.request) {
            if (!this.props.serviceType) {
                throw new Error('missing serviceType');
            } else if (this.props.serviceType === ServiceType.referral) {
                entity = 'referral';
            } else if (this.props.serviceType === ServiceType.referralSmall) {
                entity = 'referralSmall';
            } else if (this.props.serviceType === ServiceType.contact) {
                entity = 'contact';
            } else if (this.props.serviceType === ServiceType.examination) {
                entity = 'examinationRequest';
            } else if (this.props.serviceType === ServiceType.counseling) {
                entity = 'counseling';
            } else {
                entity = 'consultationRequest';
            }
        }

        await this.setState({ processType: translateKey(`processType.${entity}`) });
    }

    private getModalText(): string {
        if (this.props.isInReadMode) {
            return translateKey('cancelFormDialog.removeProcess', this.state.processType);
        } else {
            return translateKey(
                this.props.isExisting ? 'cancelFormDialog.stopEditingProcess' : 'cancelFormDialog.stopCreatingProcess',
                this.state.processType
            );
        }
    }
}
